import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../../Contexts/AuthContext';
import UI_Card from '../../ERUMAUI/UI_Card';
import UI_Input_Text from '../../ERUMAUI/UI_Input_Text';
import UI_Button from '../../ERUMAUI/UI_Button';
import UI_LinearGroup from '../../ERUMAUI/UI_LinearGroup';
import UI_Dropdown from '../../ERUMAUI/UI_Dropdown';
import { useAccounts } from '../../../Contexts/Context_Accounts';
import { useStatus } from '../../../Contexts/Context_Status_Global';
import { useScheduleManagement } from '../../../Contexts/Context_ScheduleManagement';
import UI_Icon from '../../ERUMAUI/UI_Icons';
import UI_Horizontal_Tabs from '../../ERUMAUI/UI_Horizontal_Tabs';
import { useMapRenderer } from '../../../Contexts/Context_MapRenderer';
import Tab_ScheduleManagement_Calendar from '../Tab_ScheduleManagement_Calendar';
import UI_ChipGroup from '../../ERUMAUI/UI_ChipGroup';
import UI_List_Manager from '../../ERUMAUI/UI_List_Manager';


export default function Panel_ScheduleManagement_Manager_Left() {
    const { Account, Loading, Logout } = useAuth();
    const { Schedules, Schedules_Pending_Initial, Schedules_Pending_Final, Time_Range_Parse, Status_Parse, Schedule_Display, Schedules_ByUser, Schedule_Information, Schedule_inPast } = useScheduleManagement();
    const { Room_Get_Address } = useMapRenderer();
    const { Panel_Right_State, Panel_Toggle } = useStatus();
    const Location = useLocation();
    const Parameters = new URLSearchParams(Location.search);
    const Mode = Parameters.get('view') || "All";
    const Mode_View = Mode === "OSA" ? "Tab_Pending for OSA approval" : "GSU" ? "Tab_Pending for GSU approval" : "All" ? "Tab_All" : "Tab_All";
    // useEffect(() => {
    //     console.error(Schedules);
    // }, [])
    if (Loading) {
        return null;
    }


    const Handle_Click = async (ID) => {
        await Schedule_Display(ID);
        if (Panel_Right_State == "Collapsed") {
            Panel_Toggle("Right");
        }
    }

    const User_canManage = Account.Access.Reservation.Approve.Initial || Account.Access.Reservation.Approve.Final || Account.Access.Reservation.Edit;


    return (

        <>
            {/* <h1 className='General_Title'>
                Wednesday, 3 September 2025
            </h1>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                <UI_Card
                    Shape="Rectangle"
                    Text="Pending requests"
                    Figure="10"
                    Color="Red"
                />
                <UI_Card
                    Shape="Rectangle"
                    Text="Activities today"
                    Figure="21"
                />
            </div> */}
            <UI_List_Manager
                id="Schedules_List"
                Options_Display={{
                    Composition: "Linear"
                }
                }
                Input={User_canManage ? Schedules : Schedules_ByUser}
                Keys_Searchable={["Name"]}
                Filters={{
                    Status: {
                        Options: [
                            {
                                Label: "Fully approved",
                                Icon: <UI_Icon Name="Check" />
                            },
                            {
                                Label: "Pending for OSA approval",
                                Icon: <UI_Icon Name="Partial" />
                            },
                            {
                                Label: "Pending for GSU approval",
                                Icon: <UI_Icon Name="Partial" />
                            },
                            {
                                Label: "Rejected",
                                Icon: <UI_Icon Name="Cross" />
                            },
                            {
                                Label: "Pending",
                                Icon: <UI_Icon Name="Pending" />
                            }
                        ],
                        Logic: (Item, Selected) => {
                            const Initial = Item.Approval.Initial.State;
                            const Final = Item.Approval.Final.State;
                            switch (Selected) {
                                case "Fully approved":
                                    return Initial === "Approved" && Final === "Approved";
                                case "Pending for OSA approval":
                                    return Initial === "Pending" && Final !== "Approved";
                                case "Pending for GSU approval":
                                    return Initial === "Approved" && Final === "Pending";
                                case "Rejected":
                                    return Initial === "Rejected" || Final === "Rejected";
                                case "Pending":
                                    return Initial === "Pending" && Final === "Pending";
                                case "All":
                                default:
                                    return true;
                            }
                        }
                    }
                }}
                Filter_Selected={Mode_View}
                Options_Sort={[
                    {
                        Label: "Name (A-Z)",
                        Key: "Name",
                        Direction: "Ascending"
                    },
                    // {
                    //     Label: "Newest",
                    //     Key: "Time.Start",
                    //     Direction: "Descending"
                    // },
                    {
                        Label: "Upcoming",
                        Logic: (a, b) => {
                            const now = new Date().setHours(0,0,0,0); // Get current time as a number
                            const timeA = new Date(a.Time.Start).getTime();
                            const timeB = new Date(b.Time.Start).getTime();

                            const aIsInPast = timeA < now;
                            const bIsInPast = timeB < now;

                            if (aIsInPast && !bIsInPast) {
                                return 1; 
                            }

                            if (!aIsInPast && bIsInPast) {
                                return -1; // Pushes b to the end
                            }

                            return timeA - timeB;
                        }
                    }
                ]}
                Output={(Item) => (
                    <UI_Card
                        Type="Schedule_List"
                        Figure={{
                            Title: Item.Name,
                            Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                            Chip: Status_Parse(Item),
                        }}
                        Subtype={Item._id === Schedule_Information?._id ? "Selected" : ""}
                        onClick={() => Handle_Click(Item._id)}
                    />
                )}
            />
            {/* <>
                {Account.Access.Reservation.Approve.Initial || Account.Access.Reservation.Approve.Final || Account.Access.Reservation.Edit ?
                    <>
                        

                        {Account.Access.Reservation.Approve.Initial && Schedules_Pending_Initial.length > 0 ?
                            <>
                                <h2 className='General_Title'>
                                    {Schedules_Pending_Initial.length} pending for OSA approval
                                </h2>
                                <div className='General_Grid' style={{ marginTop: "10px", marginBottom: "10px" }}>
                                    {Schedules_Pending_Initial.map((Item) => (
                                        <>
                                            {!Schedule_inPast(Item) ?
                                                <UI_Card
                                                    Type="Schedule_List"
                                                    Figure={
                                                        {
                                                            Title: Item.Name,
                                                            Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                                            Chip: Status_Parse(Item)
                                                        }
                                                    }
                                                    Subtype={Item._id === Schedule_Information?._id ? "Selected" : ""}
                                                    onClick={() => Handle_Click(Item._id)}
                                                />
                                                :
                                                ""
                                            }
                                        </>

                                    ))}
                                </div>
                                <div className='General_Grid' style={{ marginTop: "10px", marginBottom: "10px" }}>
                                    {Schedules_Pending_Initial.map((Item) => (
                                        <>
                                            {Schedule_inPast(Item) ?
                                                <UI_Card
                                                    Type="Schedule_List"
                                                    Figure={
                                                        {
                                                            Title: Item.Name,
                                                            Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                                            Chip: Status_Parse(Item)
                                                        }
                                                    }
                                                    Subtype={Item._id === Schedule_Information?._id ? "Selected" : ""}
                                                    onClick={() => Handle_Click(Item._id)}
                                                />
                                                :
                                                ""
                                            }
                                        </>

                                    ))}
                                </div>
                            </>
                            :
                            ""
                        }


                        {Account.Access.Reservation.Approve.Final && Schedules_Pending_Final.length > 0 ?
                            <>
                                <h2 className='General_Title'>
                                    {Schedules_Pending_Final.length} pending for GSU approval
                                </h2>
                                <div className='General_Grid' style={{ marginTop: "10px", marginBottom: "10px" }}>
                                    {Schedules_Pending_Final.map((Item) => (
                                        <>
                                            {!Schedule_inPast(Item) && Item?.Approval?.Initial?.State !== "Rejected" ?
                                                <UI_Card
                                                    Type="Schedule_List"
                                                    Figure={
                                                        {
                                                            Title: Item.Name,
                                                            Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                                            Chip: Status_Parse(Item)
                                                        }
                                                    }
                                                    Subtype={Item._id === Schedule_Information?._id ? "Selected" : ""}
                                                    onClick={() => Handle_Click(Item._id)}
                                                />
                                                :
                                                ""
                                            }
                                        </>

                                    ))}
                                </div>
                                <div className='General_Grid' style={{ marginTop: "10px", marginBottom: "10px" }}>
                                    {Schedules_Pending_Final.map((Item) => (
                                        <>
                                            {Schedule_inPast(Item) && Item?.Approval?.Initial?.State !== "Rejected" ?
                                                <UI_Card
                                                    Type="Schedule_List"
                                                    Figure={
                                                        {
                                                            Title: Item.Name,
                                                            Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                                            Chip: Status_Parse(Item)
                                                        }
                                                    }
                                                    Subtype={Item._id === Schedule_Information?._id ? "Selected" : ""}
                                                    onClick={() => Handle_Click(Item._id)}
                                                />
                                                :
                                                ""
                                            }
                                        </>

                                    ))}
                                </div>
                            </>
                            :
                            ""
                        }

                        <h2 className='General_Title'>
                            Approved schedules
                        </h2>
                        <div className='General_Grid' style={{ marginTop: "10px", marginBottom: "10px" }}>
                            {Schedules?.map((Item) => (
                                <>
                                    {Item.Approval.Final.State === "Approved" ?
                                        <>
                                            {!Schedule_inPast(Item) ?
                                                <UI_Card
                                                    Type="Schedule_List"
                                                    Figure={
                                                        {
                                                            Title: Item.Name,
                                                            Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                                            Chip: Status_Parse(Item)
                                                        }
                                                    }
                                                    Subtype={Item._id === Schedule_Information?._id ? "Selected" : ""}
                                                    onClick={() => Handle_Click(Item._id)}
                                                />
                                                :
                                                ""
                                            }
                                        </>
                                        :
                                        ""
                                    }

                                </>

                            ))}
                        </div>
                        <div className='General_Grid' style={{ marginTop: "10px", marginBottom: "10px" }}>
                            {Schedules?.map((Item) => (
                                <>
                                    {Item.Approval.Final.State === "Approved" ?
                                        <>
                                            {Schedule_inPast(Item) ?
                                                <UI_Card
                                                    Type="Schedule_List"
                                                    Figure={
                                                        {
                                                            Title: Item.Name,
                                                            Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                                            Chip: Status_Parse(Item)
                                                        }
                                                    }
                                                    Subtype={Item._id === Schedule_Information?._id ? "Selected" : ""}
                                                    onClick={() => Handle_Click(Item._id)}
                                                />
                                                :
                                                ""
                                            }
                                        </>
                                        :
                                        ""
                                    }

                                </>

                            ))}
                        </div>

                        <h2 className='General_Title'>
                            Rejected schedules
                        </h2>
                        <div className='General_Grid' style={{ marginTop: "10px", marginBottom: "10px" }}>
                            {Schedules?.map((Item) => (
                                <>
                                    {Item.Approval.Initial.State === "Rejected" || Item.Approval.Final.State === "Rejected" ?
                                        <>
                                            {!Schedule_inPast(Item) ?
                                                <UI_Card
                                                    Type="Schedule_List"
                                                    Figure={
                                                        {
                                                            Title: Item.Name,
                                                            Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                                            Chip: Status_Parse(Item)
                                                        }
                                                    }
                                                    Subtype={Item._id === Schedule_Information?._id ? "Selected" : ""}
                                                    onClick={() => Handle_Click(Item._id)}
                                                />
                                                :
                                                ""
                                            }
                                        </>

                                        :
                                        ""
                                    }

                                </>

                            ))}
                            {Schedules?.map((Item) => (
                                <>
                                    {Item.Approval.Initial.State === "Rejected" || Item.Approval.Final.State === "Rejected" ?
                                        <>
                                            {Schedule_inPast(Item) ?
                                                <UI_Card
                                                    Type="Schedule_List"
                                                    Figure={
                                                        {
                                                            Title: Item.Name,
                                                            Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                                            Chip: Status_Parse(Item)
                                                        }
                                                    }
                                                    Subtype={Item._id === Schedule_Information?._id ? "Selected" : ""}
                                                    onClick={() => Handle_Click(Item._id)}
                                                />
                                                :
                                                ""
                                            }
                                        </>

                                        :
                                        ""
                                    }

                                </>

                            ))}
                        </div>
                    </>
                    :
                    ""
                }
            </> */}
            {/* {User_canManage ?
                <UI_Horizontal_Tabs
                    Selectors={[
                        {
                            Icon: <UI_Icon Name="Schedule" />,
                            Text: "Pending schedules"
                        },
                        {
                            Icon: <UI_Icon Name="Schedule" />,
                            Text: "Your reservations"
                        }
                    ]}
                    UIDs={["Pending", "ByUser"]}
                    Components={[
                        <>
                            {Account.Access.Reservation.Approve.Initial || Account.Access.Reservation.Approve.Final || Account.Access.Reservation.Edit ?
                                <>
                                    {Account.Access.Reservation.Approve.Initial && Schedules_Pending_Initial.length > 0 ?
                                        <>
                                            <h2 className='General_Title'>
                                                {Schedules_Pending_Initial.length} pending for OSA approval
                                            </h2>
                                            <div className='General_Grid' style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                {Schedules_Pending_Initial.map((Item) => (
                                                    <>
                                                        {!Schedule_inPast(Item) ?
                                                            <UI_Card
                                                                Type="Schedule_List"
                                                                Figure={
                                                                    {
                                                                        Title: Item.Name,
                                                                        Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                                                        Chip: Status_Parse(Item)
                                                                    }
                                                                }
                                                                Subtype={Item._id === Schedule_Information?._id ? "Selected" : ""}
                                                                onClick={() => Handle_Click(Item._id)}
                                                            />
                                                            :
                                                            ""
                                                        }
                                                    </>

                                                ))}
                                            </div>
                                            <div className='General_Grid' style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                {Schedules_Pending_Initial.map((Item) => (
                                                    <>
                                                        {Schedule_inPast(Item) ?
                                                            <UI_Card
                                                                Type="Schedule_List"
                                                                Figure={
                                                                    {
                                                                        Title: Item.Name,
                                                                        Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                                                        Chip: Status_Parse(Item)
                                                                    }
                                                                }
                                                                Subtype={Item._id === Schedule_Information?._id ? "Selected" : ""}
                                                                onClick={() => Handle_Click(Item._id)}
                                                            />
                                                            :
                                                            ""
                                                        }
                                                    </>

                                                ))}
                                            </div>
                                        </>
                                        :
                                        ""
                                    }


                                    {Account.Access.Reservation.Approve.Final && Schedules_Pending_Final.length > 0 ?
                                        <>
                                            <h2 className='General_Title'>
                                                {Schedules_Pending_Final.length} pending for GSU approval
                                            </h2>
                                            <div className='General_Grid' style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                {Schedules_Pending_Final.map((Item) => (
                                                    <>
                                                        {!Schedule_inPast(Item) ?
                                                            <UI_Card
                                                                Type="Schedule_List"
                                                                Figure={
                                                                    {
                                                                        Title: Item.Name,
                                                                        Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                                                        Chip: Status_Parse(Item)
                                                                    }
                                                                }
                                                                Subtype={Item._id === Schedule_Information?._id ? "Selected" : ""}
                                                                onClick={() => Handle_Click(Item._id)}
                                                            />
                                                            :
                                                            ""
                                                        }
                                                    </>

                                                ))}
                                            </div>
                                            <div className='General_Grid' style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                {Schedules_Pending_Final.map((Item) => (
                                                    <>
                                                        {Schedule_inPast(Item) ?
                                                            <UI_Card
                                                                Type="Schedule_List"
                                                                Figure={
                                                                    {
                                                                        Title: Item.Name,
                                                                        Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                                                        Chip: Status_Parse(Item)
                                                                    }
                                                                }
                                                                Subtype={Item._id === Schedule_Information?._id ? "Selected" : ""}
                                                                onClick={() => Handle_Click(Item._id)}
                                                            />
                                                            :
                                                            ""
                                                        }
                                                    </>

                                                ))}
                                            </div>
                                        </>
                                        :
                                        ""
                                    }

                                    <h2 className='General_Title'>
                                        Approved schedules
                                    </h2>
                                    <div className='General_Grid' style={{ marginTop: "10px", marginBottom: "10px" }}>
                                        {Schedules?.map((Item) => (
                                            <>
                                                {Item.Approval.Final.State === "Approved" ?
                                                    <>
                                                        {!Schedule_inPast(Item) ?
                                                            <UI_Card
                                                                Type="Schedule_List"
                                                                Figure={
                                                                    {
                                                                        Title: Item.Name,
                                                                        Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                                                        Chip: Status_Parse(Item)
                                                                    }
                                                                }
                                                                Subtype={Item._id === Schedule_Information?._id ? "Selected" : ""}
                                                                onClick={() => Handle_Click(Item._id)}
                                                            />
                                                            :
                                                            ""
                                                        }
                                                    </>
                                                    :
                                                    ""
                                                }

                                            </>

                                        ))}
                                    </div>
                                    <div className='General_Grid' style={{ marginTop: "10px", marginBottom: "10px" }}>
                                        {Schedules?.map((Item) => (
                                            <>
                                                {Item.Approval.Final.State === "Approved" ?
                                                    <>
                                                        {Schedule_inPast(Item) ?
                                                            <UI_Card
                                                                Type="Schedule_List"
                                                                Figure={
                                                                    {
                                                                        Title: Item.Name,
                                                                        Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                                                        Chip: Status_Parse(Item)
                                                                    }
                                                                }
                                                                Subtype={Item._id === Schedule_Information?._id ? "Selected" : ""}
                                                                onClick={() => Handle_Click(Item._id)}
                                                            />
                                                            :
                                                            ""
                                                        }
                                                    </>
                                                    :
                                                    ""
                                                }

                                            </>

                                        ))}
                                    </div>

                                    <h2 className='General_Title'>
                                        Rejected schedules
                                    </h2>
                                    <div className='General_Grid' style={{ marginTop: "10px", marginBottom: "10px" }}>
                                        {Schedules?.map((Item) => (
                                            <>
                                                {Item.Approval.Initial.State === "Rejected" || Item.Approval.Final.State === "Rejected" ?
                                                    <>
                                                        {!Schedule_inPast(Item) ?
                                                            <UI_Card
                                                                Type="Schedule_List"
                                                                Figure={
                                                                    {
                                                                        Title: Item.Name,
                                                                        Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                                                        Chip: Status_Parse(Item)
                                                                    }
                                                                }
                                                                Subtype={Item._id === Schedule_Information?._id ? "Selected" : ""}
                                                                onClick={() => Handle_Click(Item._id)}
                                                            />
                                                            :
                                                            ""
                                                        }
                                                    </>

                                                    :
                                                    ""
                                                }

                                            </>

                                        ))}
                                        {Schedules?.map((Item) => (
                                            <>
                                                {Item.Approval.Initial.State === "Rejected" || Item.Approval.Final.State === "Rejected" ?
                                                    <>
                                                        {Schedule_inPast(Item) ?
                                                            <UI_Card
                                                                Type="Schedule_List"
                                                                Figure={
                                                                    {
                                                                        Title: Item.Name,
                                                                        Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                                                        Chip: Status_Parse(Item)
                                                                    }
                                                                }
                                                                Subtype={Item._id === Schedule_Information?._id ? "Selected" : ""}
                                                                onClick={() => Handle_Click(Item._id)}
                                                            />
                                                            :
                                                            ""
                                                        }
                                                    </>

                                                    :
                                                    ""
                                                }

                                            </>

                                        ))}
                                    </div>
                                </>
                                :
                                ""
                            }
                        </>,
                        <>
                            {Schedules_ByUser.length > 0 ?
                                <>
                                    <h2 className='General_Title'>
                                        {Schedules_ByUser.length} reservation requests
                                    </h2>
                                    <div className='General_Grid' style={{ marginTop: "10px", marginBottom: "10px" }}>
                                        {Schedules_ByUser.map((Item) => (
                                            <>
                                                {!Schedule_inPast(Item) ?
                                                    <UI_Card
                                                        Type="Schedule_List"
                                                        Figure={
                                                            {
                                                                Title: Item.Name,
                                                                Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                                                Chip: Status_Parse(Item)
                                                            }
                                                        }
                                                        Subtype={Item._id === Schedule_Information?._id ? "Selected" : ""}
                                                        onClick={() => Handle_Click(Item._id)}
                                                    />
                                                    :
                                                    ""
                                                }
                                            </>

                                        ))}
                                    </div>
                                </>
                                :
                                ""
                            }
                        </>
                    ]}
                />
                :
                <>
                    {Schedules_ByUser.length > 0 ?
                        <>
                            <h2 className='General_Title'>
                                {Schedules_ByUser.length} reservation requests
                            </h2>
                            <div className='General_Grid' style={{ marginTop: "10px", marginBottom: "10px" }}>
                                {Schedules_ByUser.map((Item) => (
                                    <>
                                        <UI_Card
                                            Type="Schedule_List"
                                            Figure={
                                                {
                                                    Title: Item.Name,
                                                    Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                                    Chip: Status_Parse(Item)
                                                }
                                            }
                                            Subtype={Item._id === Schedule_Information?._id ? "Selected" : ""}
                                            onClick={() => Handle_Click(Item._id)}
                                        />
                                    </>

                                ))}
                            </div>
                        </>
                        :
                        ""
                    }
                </>
            } */}



        </>
    );
}
